export default function (props: any) {
    return (
        <svg
            width="34px"
            height="40px"
            viewBox="0 0 34 40"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="-M端-Smart-Generator-(Dual-Fuel)" transform="translate(-254.000000, -3584.000000)" fill="#FF5641" fillRule="nonzero">
                    <g id="燃料供货源" transform="translate(254.000000, 3584.000000)">
                        <path
                            d="M30.94,40 L3.06000001,40 C1.36000002,40 0,38.6857143 0,37.0285714 L0,6.85714285 C0,5.2 1.35999998,3.8857143 3.06000001,3.8857143 L4.76,3.8857143 C4.1965648,3.49944481 3.85755156,2.85845338 3.85333334,2.17142855 C3.85333334,0.971428555 4.87333336,0 6.06333332,0 L15.3566667,0 C16.6033333,0 17.5666667,0.971428555 17.5666666,2.17142855 C17.5666666,3.14285711 16.8866666,4 15.98,4.22857145 L15.98,4.6857143 L32.6966666,15.6 C33.49,16.1142857 34,17.0857143 34,18.0571429 L34,37.0285714 C34,38.6285714 32.64,40 30.94,40 Z M3.06000001,6.22857145 C2.60666668,6.22857145 2.26666668,6.51428574 2.26666668,6.85714285 L2.26666668,36.9714286 C2.26666668,37.3142857 2.60666668,37.6 3.06000001,37.6 L30.94,37.6 C31.3933333,37.6 31.7333333,37.3142857 31.7333333,36.9714286 L31.7333333,18.0571429 C31.7333333,17.8857143 31.62,17.6571429 31.45,17.5428571 L13.7133333,6 L13.7133333,2.34285715 L7.53666666,2.34285715 L7.53666666,6.22857145 L3.06000001,6.22857145 Z"
                            id="形状"
                        ></path>
                        <path
                            d="M21.7304149,31.3968958 C20.5689095,32.5203252 18.8266516,33.1707317 17.0263183,33.1707317 C13.5418023,33.1707317 10.6961143,30.7464893 10.6961143,27.7900961 C10.638039,27.4353289 10.638039,24.1832964 16.0390388,16.9105691 L16.968243,15.6097561 L17.9555226,16.8514412 C18.1297483,17.0879527 22.8919201,23.2372505 23.298447,27.7309682 C23.4145975,29.0317812 22.8919201,30.3325942 21.7304149,31.3968958 Z"
                            id="路径"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
